export default class Blog {
	static getHolderSelectors = () => ['.blog'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		const filters = holderElement.querySelectorAll('.filters form');
		const path = window.location.pathname.replace(/\/+$/, '');

		for (const filter of filters) {
			const select = filter.querySelector('select');
			for (const option of select.options) {
				if (path === option.value.replace(/\/+$/, '')) {
					select.value = option.value;
				}
			}
			select.addEventListener('change', () => {
				window.location = select.value;
			});
		}

	}
}
